export function stateFromWebOrder(webOrder) {
  const state = {
    address: {},
    segment: {},
    information: {},
  }

  if (webOrder) {
    state.information = {
      brokerId: webOrder.broker.id,
      customerRef: webOrder.customerRef,
      floors: webOrder.floors,
      m2: webOrder.m2,
      floorNumber: webOrder.floorNumber,
    }

    if (webOrder.estateSellers.length) {
      state.information.estateSellers = webOrder.estateSellers.map((seller) => ({
        id: seller.id,
        type: seller.type,
        name: seller.name,
        email: seller.email,
        phone: seller.phone,
      }))
    }

    if (webOrder.address) {
      state.address = {
        id: webOrder.cadastreAddressId || null,
        street: webOrder.address.street,
        postalCode: webOrder.address.postalCode,
        postalArea: webOrder.address.postalArea,
        location: webOrder.address.location,
      }
    }

    if (webOrder.segment) {
      state.segment = {
        id: webOrder.segment.id,
        iconUrl: webOrder.segment.iconUrl,
        type: webOrder.segment.type,
      }
    }
  }

  return state
}

export function webOrderInputFromState(state) {
  const address = state.address || {}
  return {
    brokerId: state.information.brokerId,
    addressId: address.id,
    segmentId: state.segment.id,
    estateAddressFloorNumber: state.information.floorNumber,
    customerRef: state.information.customerRef,
    estateSellers: state.information.estateSellers,
    hasRentalUnit: state.information.hasRentalUnit,
    floors: state.information.floors,
    m2: state.information.m2,
    address: {
      bnr: address.bnr,
      gnr: address.gnr,
      id: address.id,
      knr: address.knr,
      location: address.location
        ? {
          lat: address.location.lat,
          lon: address.location.lon,
        }
        : null,
      number: address.number,
      postalArea: address.postalArea,
      postalCode: address.postalCode,
      street: address.street,
    },
  }
}
